import { useEffect } from "react";

const DEFAULT_TITLE =
  "Creative Sales Source LLC | The Trusted Connection Between Building Manufacturers and Dealers";
const DEFAULT_DESCRIPTION =
  "Creative Sales Source LLC — the trusted connection between building manufacturers and dealers. Outsourced sales representation across the Midwest since 2012.";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * useDocumentMeta — set per-route <title>, meta description, OpenGraph,
 * Twitter card, and canonical URL. Resets to defaults on unmount.
 */
export function useDocumentMeta({ title, description, image, path }) {
  useEffect(() => {
    const fullTitle = title || DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;
    const origin =
      typeof window !== "undefined" && window.location
        ? window.location.origin
        : "https://creativesalessource.com";
    const canonical = origin + (path || (typeof window !== "undefined" ? window.location.pathname : ""));

    document.title = fullTitle;
    setMeta("description", desc);

    // OpenGraph
    setMeta("og:title", fullTitle, "property");
    setMeta("og:description", desc, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:url", canonical, "property");
    setMeta(
      "og:image",
      image ||
        `${origin}/uploads/lumber-semi.png`,
      "property"
    );
    setMeta("og:site_name", "Creative Sales Source LLC", "property");

    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", desc);

    setCanonical(canonical);

    return () => {
      document.title = DEFAULT_TITLE;
      setMeta("description", DEFAULT_DESCRIPTION);
    };
  }, [title, description, image, path]);
}

export default useDocumentMeta;
